import { render, staticRenderFns } from "./ContentsCreate.vue?vue&type=template&id=9560ffba&"
import script from "./ContentsCreate.vue?vue&type=script&lang=js&"
export * from "./ContentsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports